import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchInquiryByPatient } from "../../../store/slices/inquirySlice";
import AddPatientInquiry from "./AddPatientInquiry";
import EditPatientInquiry from "./EditPatientInquiry";

const EnquiryForm = () => {
  const { id: patientId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, error, currentInquiry } = useSelector((state) => state.inquiries);
  const [hasInquiry, setHasInquiry] = useState(null);
  const [inquiryData, setInquiryData] = useState(null);

  useEffect(() => {
    console.log("Dispatching fetchInquiryByPatient for patientId:", patientId);
    dispatch(fetchInquiryByPatient(patientId));
  }, [dispatch, patientId]);

  useEffect(() => {
    console.log("useEffect triggered - currentInquiry:", currentInquiry, "isLoading:", isLoading, "error:", error);
    if (currentInquiry) {
      console.log("Current inquiry from store:", currentInquiry);
      if (currentInquiry.master || (currentInquiry.clientInformation && currentInquiry.clientMedications && currentInquiry.clientHistory && currentInquiry.riskForm)) {
        setHasInquiry(true);
        setInquiryData(currentInquiry);
      } else {
        setHasInquiry(false);
      }
    } else if (!isLoading && !error) {
      console.log("No inquiry found or loading complete with no error");
      setHasInquiry(false);
    } else if (error) {
      console.log("Error occurred:", error);
    }
  }, [currentInquiry, isLoading, error]);

  if (hasInquiry === null) return <div>Loading inquiry details...</div>;
  console.log("Rendering EnquiryForm, hasInquiry:", hasInquiry);
  return hasInquiry ? (
    <EditPatientInquiry inquiryData={inquiryData} />
  ) : (
    <AddPatientInquiry />
  );
};

export default EnquiryForm;